module.exports = __webpack_public_path__ + "static/img/color.bbf69f90.jpg";